import { render, staticRenderFns } from "./CommonTableLawGroup.vue?vue&type=template&id=6fdf3b8e&"
import script from "./CommonTableLawGroup.vue?vue&type=script&lang=js&"
export * from "./CommonTableLawGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports